import { Tooltip, TooltipProps, Typography, TypographyProps } from '@mui/material';
import { FC, useCallback, useRef, useState } from 'react';

export interface OverflowTooltipProps {
  children: string;
  typographyProps?: Omit<TypographyProps, 'children' | 'noWrap'>;
  tooltipProps?: Omit<TooltipProps, 'title' | 'children' | 'open' | 'onOpen' | 'onClose'>;
}

export const OverflowTooltip: FC<OverflowTooltipProps> = ({
  children,
  typographyProps,
  tooltipProps,
}) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    const el = textRef.current;
    if (el && el.scrollWidth > el.offsetWidth) {
      setOpen(true);
    }
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <Tooltip
      title={children}
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      {...tooltipProps}
    >
      <Typography
        ref={textRef}
        noWrap
        sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
        {...typographyProps}
      >
        {children}
      </Typography>
    </Tooltip>
  );
};
